<template>
  <!--台州仲案件-->
  <div class="body">
    <service-tabbar current="1" />
    <div class="content">
      <div class="left-tab-warp">
        <left-tab></left-tab>
      </div>
      <div class="right-wrap">
        <div class="right-content">
          <div class="right-toolbar">
            <h2 class="title">台州仲案件</h2>
            <div class="right">
              <el-button @click="toConsumeList()" class="btn" size="small"
                >消费记录</el-button
              >
              <el-button
                @click="toCreateCase()"
                class="btn"
                type="primary"
                size="small"
                >发布案件</el-button
              >
            </div>
          </div>
          <div class="table-warp">
            <el-row class="row" :gutter="20" style="margin: 0">
              <el-col :span="2">
                <p style="line-height: 34px; font-weight: 600">关键字</p>
              </el-col>
              <el-col :span="4">
                <el-input
                  v-model="claimantName"
                  size="small"
                  placeholder="申请人"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <el-input
                  v-model="respondentName"
                  size="small"
                  placeholder="被申请人"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <el-input
                  v-model="caseNo"
                  size="small"
                  placeholder="案件号"
                ></el-input>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="caseStatus"
                  placeholder="请选择状态"
                  size="small"
                >
                  <el-option label="全部" value="" />
                  <el-option label="待立案 " :value="9" />
                  <el-option label="已立案" :value="10" />
                  <el-option label="开庭" :value="17" />
                  <el-option label="审理中" :value="18" />
                  <el-option label="裁决" :value="19" />
                  <el-option label="调解仲裁" :value="20" />
                  <el-option label="已撤案" :value="21" />
                  <el-option label="不受理" :value="13" />
                </el-select>
              </el-col>
              <el-col :span="7" class="search-btn-warp">
                <el-button @click="buttonQuery" size="small">查询</el-button>
              </el-col>
            </el-row>
            <el-table
              v-loading="loading"
              class="data-list"
              :data="listData"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500',
              }"
              :style="{ 'min-height': tableHeight + 'px' }"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column
                label="申请流水号"
                prop="orderNo"
                show-overflow-tooltip
              />
              <el-table-column label="仲裁案号" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.caseNo || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="发布时间" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.createTime | formatDateTime }}
                </template>
              </el-table-column>
              <el-table-column label="订单金额" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.controversyAmount || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="申请人" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.claimantName || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="被申请人" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.respondentName || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.caseStatusStr || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.caseStatus == 19"
                    @click="toDown(scope.row.orderNo)"
                    class="color-success pointer"
                    >下载文书</span
                  >
                  <span
                    v-else-if="
                      scope.row.caseStatus == 21 || (13 && scope.row.caseId)
                    "
                    @click="toDelete(scope.row.caseId)"
                    class="color-success pointer"
                    >删除</span
                  >
                  <span
                    v-else
                    @click="revoke(scope.row.orderNo)"
                    class="color-success pointer"
                    >撤案</span
                  >
                </template>
              </el-table-column>
              <!--        <no-data text="还未申请过仲裁" slot="empty"/>-->
              <div slot="empty" class="com-custom-nodata">
                <div class="bx">
                  <h1>时间短·费用低·支持批量</h1>
                  <p>
                    <span class="rd"
                      >联合仲裁委共同推出，文书自动生成，一键立案</span
                    ><span class="rd"
                      >智能判例匹配，异地服务协同，5~10天出裁决书</span
                    >
                  </p>
                  <p>
                    <span class="rd"
                      >一裁终决，成本可降至传统诉讼的十分之一</span
                    >
                  </p>
                  <img class="simg" src="/images/web/nodata-zc.png" />
                </div>
              </div>
            </el-table>

            <div
              class="pageation row page-flex-end"
              v-if="listData && listData.length > 0"
              style="position: relative"
            >
              <el-pagination
                v-if="paged.total > 0"
                @size-change="handleSizeChange"
                :pager-count="5"
                @current-change="handleCurrentChange"
                :total="paged.total"
                :current-page.sync="paged.pageNum"
                :page-size="paged.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                layout="sizes, prev, pager, next, total"
              />
              <el-go
                :page-size="paged.pageSize"
                :total="paged.total"
                @current-change="handleCurrentChange"
              ></el-go>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="showProgressDialog"
      title="进度查询"
      width="500px"
      :close-on-click-modal="false"
    >
      <div style="margin-top: 15px">
        <div class="row">
          <div class="col-xs-8">
            <h5 class="list-title">
              立案号：<span name="arbcaseId">{{ progressData.caseNo }}</span>
            </h5>
          </div>
        </div>
        <ul class="list-step" style="margin-top: 30px; margin-bottom: 30px">
          <li
            :class="{
              active: progressData.caseState == 0,
              finished: progressData.caseState > 0,
            }"
          >
            <span class="step-item step-1"
              ><img src="/images/arbitation/step_1.png"
            /></span>
            <div class="word-keep">申请中</div>
          </li>
          <li :class="{ finished: progressData.caseState > 0, arrow: true }">
            <i class="el-icon-arrow-right"></i>
          </li>
          <li
            :class="{
              active: progressData.caseState == 1,
              finished: progressData.caseState > 1,
            }"
          >
            <span class="step-item step-2"
              ><img src="/images/arbitation/step_2.png"
            /></span>
            <div class="word-keep">已立案</div>
          </li>
          <li :class="{ finished: progressData.caseState > 1, arrow: true }">
            <i class="el-icon-arrow-right"></i>
          </li>
          <li
            :class="{
              active: progressData.caseState == 2,
              finished: progressData.caseState > 2,
            }"
          >
            <span class="step-item step-3"
              ><img src="/images/arbitation/step_3.png"
            /></span>
            <div class="word-keep">审核中</div>
          </li>
          <li :class="{ finished: progressData.caseState > 2, arrow: true }">
            <i class="el-icon-arrow-right"></i>
          </li>
          <li
            :class="{
              active: progressData.caseState == 3,
              finished: progressData.caseState > 3,
            }"
          >
            <span class="step-item step-4"
              ><img src="/images/arbitation/step_4.png"
            /></span>
            <div class="word-keep">已结案</div>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          @click="showProgressDialog = false"
          size="small"
          type="danger"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <goto-auth :authDialog.sync="authDialog"></goto-auth>
  </div>
</template>

<script>
import { ApiMethods } from '@/assets/js/http-serve/http-methods';
import ElGo from '@/components/go/Go';
import LeftTab from '@/components/judicialService/leftTab';
import ServiceTabbar from '@/components/judicialService/tabbar'
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  components: { ElGo, LeftTab, ServiceTabbar },
  methods: {
    conso: function (tab, event) {
      this.$router.push(tab.name)
    },
    // queryProgress:function(item){
    //     var _this = this, param = {arbcaseId: item.arbcaseId};
    //     ApiMethods.SafeguardController.arbitCaseInfo(param).then(result => {
    //         if(!result.success){
    //             return _this.$message.error(result.description || "查询状态失败")
    //         }
    //         _this.progressData = result.data;
    //     });
    // },
    toDown (param) {
      ApiMethods.SafeguardController.hzDownWrit({ orderNo: param }).then(res => {
        if (res.success) {
          this.$message.success(res.description)
        } else {
          this.$message.error(res.description)
        }
      })
    },
    toDelete (param) {
      ApiMethods.SafeguardController.hzDeleteCase({ caseId: param }).then(res => {
        console.log(res)
        if (res.success) {
          this.$message.success(res.description);
          this.queryList();
        } else {
          this.$message.error(res.description);
        }
      })
    },
    revoke (arbcaseId) {
      this.$confirm('是否撤销案件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await ApiMethods.SafeguardController.caseClaimWithdraw({ arbcaseId: arbcaseId });
        if (!res.success) {
          return this.$message.error(res.description || "案件撤销失败");
        }
        this.$message.success(res.description || "案件撤销成功");
        this.queryList();
      }).catch(() => {
        // 取消撤销
      });
    },
    queryList: function () {
      var param = { pageSize: this.paged.pageSize, itemPage: this.paged.pageNum, arbId: 1 };
      this.loading = true;
      ApiMethods.SafeguardController.hzArbitration(param).then(result => {
        if (!result.success && this.$store.getters.authUser.identityAuth > -1) {
          return this.$message.error(result.description || "查询数据失败")
        }
        this.paged = { pageNum: result.pageNum, pageSize: result.pageSize, pages: result.pages, total: result.total };
        this.listData = result.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    // 点击查询按钮
    buttonQuery () {
      // 重置起始页数，查询所有数据
      this.paged.pageNum = 1;
      this.queryList();
    },
    toCreateCase: function () {
      if (this.$store.getters.authUser.identityAuth > -1) {
        var _this = this, url = _this.globalConfig.domain.arbitrationUrl + '/arbitration/hz/step1.html?arbId=' + 1;
        isInDingTalk ? location.href = url : window.open(url, "_blank")
      } else {
        this.authDialog = true
      }
    },
    toConsumeList () {
      var _this = this, url = _this.globalConfig.domain.arbitrationUrl + '/arbitration/tz/expenseCalendar.html';
      isInDingTalk ? location.href = url : window.open(url, "_blank")
    },
    handleSelectionChange: function (val) {
      this.checkedList = val;
    },
    handleCurrentChange: function (val) {
      this.paged.pageNum = val;
      this.queryList();
    },
    handleSizeChange: function (val) {
      this.paged.pageSize = val;
      this.queryList();
    },
  },
  created () {
    this.queryList();
  },
  mounted () {
    // 适配高度（底部可能没有）
    let height = this.tableHeight
    try {
      let body = document.getElementsByTagName('body')
      let header = document.getElementsByClassName('el-header')
      let pageation = document.getElementsByClassName('pageation')
      let contacts = document.getElementsByClassName('contacts')
      let footer = document.getElementsByClassName('el-footer')
      body = body && body.length > 0 ? body[0].clientHeight : 0
      header = header && header.length > 0 ? header[0].clientHeight : 0
      pageation = pageation && pageation.length > 0 ? pageation[0].clientHeight : 0
      contacts = contacts && contacts.length > 0 ? contacts[0].clientHeight : 0
      footer = footer && footer.length > 0 ? footer[0].clientHeight : 0
      height = body - header - pageation - contacts - footer - 160
    } catch (e) {
      console.error(e)
    }
    this.tableHeight = height
  },
  data () {
    return {
      paged: { pageNum: 1, pageSize: 10 },
      listData: [],
      checkedList: [],
      showProgressDialog: false,
      progressData: {},
      claimantName: '',
      respondentName: '',
      caseStatus: '',
      caseNo: '',
      loading: false,
      activeName: '/judicialService/taiarbitration',
      authDialog: false,
      tableHeight: 700
    }
  },
  name: "taiarbitration"
}
</script>

<style lang="less" scoped>
.list-step {
  color: #7f828b;
  list-style: none;
  .active {
    color: #ec1c1c;
  }
  .finished {
    color: #009899;
  }
  img {
    background-color: #7f828b;
  }
  .active img {
    background-color: #ec1c1c;
  }
  .finished img {
    background-color: #009899;
  }
  li {
    text-align: center;
    display: inline-block;
    width: 20%;
  }
  li.arrow {
    width: 6%;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    vertical-align: top;
  }
}
.body {
  height: 100%;
  max-width: 1200px;
  position: relative;
  display: block;
  margin: 76px auto 0;
  background: #ffffff;
  border-radius: 14px;
  box-sizing: border-box;
  padding: 20px 15px 15px;
  .safeguard-bar {
    width: 100%;
    margin-top: 20px;
    border: 1px dashed #d7d7d7;
    overflow: hidden;
    ul {
      li {
        display: inline-block;
        margin-right: 14px;
        padding: 10px;
        color: #666;
        border: none;
        background: #fff;
        cursor: pointer;
      }
      li.active {
        color: #ec1c1c;
      }
    }
  }
  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
  }
  .dialog-footer {
    padding-bottom: 20px;
    .btn {
      width: 30%;
    }
  }
}
.color-success {
  color: #290202;
  font-weight: bold;
  cursor: pointer;
}
.color-success:hover {
  color: #ec1c1c;
}
.right-wrap {
  position: relative;
  padding-left: 15px;
  flex: 1;
  width: 0;
  .table-wrap {
    padding: 0 16px;
  }

  /deep/ .row {
    padding: 15px 0 0;
    height: 62px;
    min-height: 62px;
  }

  /deep/ .data-list {
    /*height: calc(100vh - 407px);*/
    width: inherit;
    margin: 0 0;
    border: 1px solid #eeeeee;
  }

  /deep/ .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }

  /deep/ .go-style {
    top: 17px;
  }
}
.content {
  background: #f8f8f8;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 25px 15px 10px;
  display: flex;
}
.left-tab-warp {
  flex: 0 0 200px;
}
.right-content {
  width: 100%;

  background-color: #fff;
  box-sizing: border-box;
}

.table-warp {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
}
.right-toolbar {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  .title {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: #290202;
    &::before {
      content: "";
      width: 5px;
      height: 15px;
      background: #290202;
      margin-right: 10px;
    }
  }
  .right {
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 15px;
  }
  .btn {
    width: 65px;
    padding: 8px 0;
    margin-left: 10px;
  }
}
.search-btn-warp {
  padding-right: 0 !important;
  text-align: right;
}
.table-warp .el-col {
  padding-left: 0 !important;
}
</style>
<style scoped>
/deep/ .el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
/deep/ .el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 20px !important;
}
/deep/ .el-tabs__active-bar {
  display: none;
}
/deep/ .el-tabs__item.is-active {
  color: #ec1c1c;
  border-bottom: 2px solid #ec1c1c;
}
/deep/ .el-tabs__item:hover {
  color: #ec1c1c;
}
/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// pages/judicialService/taiarbitration.vue